import {
    Checkbox,
    Grid,
    makeStyles,
    Theme,
    createStyles,
} from "@material-ui/core";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { AnnounceInputs } from "../../../../utils/AnnounceInterfaces";
import { ELinks } from "../../../../utils/enum";
import { linksStringToData, setRef } from "../../../../utils/footerUtils";
import { PropertyTextField } from "../PropertyTextField";
import { PropertyTextFieldMulitline } from "../PropertyTextFieldMulitline";
import { PropertyTextFieldNum } from "../PropertyTextFieldNum";
import * as footerService from "../../../../Services/footerServices";
import { ELinksURL } from "../../../../utils/enum/linksOnFooter";

export const StepEight = (props: {
    values: AnnounceInputs;
    acceptConditions: boolean;
    handleAcceptConditions: () => void;
    handleChange: (e: any) => void;
    searchTypeName?: string;
    codePhone?: any;
}) => {
    const [links, setLinks] = React.useState<any>({});
    const [, setGetingLinks] = React.useState(false);
    const { t } = useTranslation<'common'>();
    const classes = styles();
    const SearchTypeName = props.searchTypeName;

    React.useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    }, []);

    React.useEffect(() => {

        //console.log("Fetching Footer data from StepEight.tsx component");
        setGetingLinks(true);
        footerService
            .getFooterData()
            .then((resp) => {
                if (resp && resp.links) {
                    let upData = linksStringToData(resp.links);
                    setLinks(upData);
                }
                setGetingLinks(false);
            })
            .catch((err) => {
                console.error(err);
                setGetingLinks(false);
            });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <Grid
                container
                spacing={1}
                style={{ textAlign: "left" }}
                direction="row"
                alignItems="center"
            >
                <Grid item className={classes.titles}>
                    {t("annonce.labels.comment-acceder")}
                </Grid>
                <Grid item style={{ lineHeight: "22px" }}>
                {SearchTypeName === "rstt" ? t("annonce.labels.decrivez-comment-immobilier") : t("annonce.labels.decrivez-comment-les-voyageurs")}
                </Grid>
                <Grid item xs={6} sm={3}>
                    <label htmlFor="contactName" className={classes.inputLabel}>
                        {t("annonce.labels.nom-du-contact")}
                    </label>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <PropertyTextField
                        id="contactName"
                        label=""
                        name="contactName"
                        value={props.values.contactName}
                        handleChange={props.handleChange}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={6} sm={3}>
                    <label
                        htmlFor="contactPhone"
                        className={classes.inputLabel}
                    >
                        {t("annonce.labels.numero-du-contact")}
                    </label>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <PropertyTextFieldNum
                        id="contactPhone"
                        codenum={props.codePhone}
                        label=""
                        name="contactPhone"
                        value={props.values.contactPhone}
                        handleChange={props.handleChange}
                        variant="standard"
                    />
                </Grid>
                <Grid item xs={12}>
                    <PropertyTextFieldMulitline
                        id="howToAccessDesc"
                        label=""
                        name="howToAccessDesc"
                        value={props.values.howToAccessDesc}
                        minRows={5}
                        handleChange={props.handleChange}
                    />
                </Grid>
                <Grid item xs={4}>
                    <label htmlFor="sponsorshipCode">
                    {`${t('propriete.labels.localisationGPS')} :`}
                    </label>
                </Grid>
                <Grid item xs={8}>
                    <PropertyTextField
                        id="sponsorshipCode"
                        label=""
                        name="sponsorshipCode"
                        value={props.values.sponsorshipCode}
                        handleChange={props.handleChange}
                        variant="standard"
                    />
                </Grid>
                <Grid item className={classes.titles}>
                    {t("annonce.labels.vos-engagements")}
                </Grid>
                <Grid item style={{ lineHeight: "22px" }}>
                    {t("annonce.labels.votre-liaison-commerciale")} :
                </Grid>
                <Grid item>
                    <ul style={{ lineHeight: "22px" }}>
                        <li style={{ marginBottom: 4 }}>
                            {t("annonce.labels.le-temps-de-reponse")}
                        </li>
                        <li>
                            {t("annonce.labels.la-satisfaction-des-voyageurs")}
                        </li>
                    </ul>
                </Grid>
                <Grid item xs={2} sm={1}>
                    <Checkbox
                        checked={props.acceptConditions}
                        onChange={props.handleAcceptConditions}
                    />
                </Grid>
                <Grid item xs={10} sm={11} style={{ lineHeight: "22px" }}>
                    {`${t("annonce.labels.en-creant-une-annonce.item1")} `}
                    <Link
                        to={{
                            pathname: `${ELinksURL.CGU}`,
                            state: links[setRef(ELinks.CGU).key]?.state,
                        }}
                        style={{ fontWeight: 700 }}
                        target="_blank"
                    >
                        {t("annonce.labels.en-creant-une-annonce.link1")}
                    </Link>
                    {`${t("annonce.labels.en-creant-une-annonce.item2")} `}
                    <Link
                        to={{
                            pathname: `${ELinksURL.PDC}`,
                            state: links[setRef(ELinks.PDC).key]?.state,
                        }}
                        style={{ fontWeight: 700 }}
                        target="_blank"
                    >
                        {t("annonce.labels.en-creant-une-annonce.link2")}
                    </Link>
                </Grid>
                {/*<Grid item xs={4}>
                    <label htmlFor="sponsorshipCode">
                        {t("annonce.labels.code-parrainage")}
                    </label>
                </Grid>
                <Grid item xs={3}>
                    <PropertyTextField
                        id="sponsorshipCode"
                        label="sponsorshipCode"
                        name="sponsorshipCode"
                        value={props.values.sponsorshipCode}
                        handleChange={props.handleChange}
                        variant="standard"
                    />
                </Grid>*/}
            </Grid>
        </>
    );
};

const styles = makeStyles((theme: Theme) =>
    createStyles({
        inpuText: {
            marginBottom: 14,
            marginTop: 6,
        },
        inputText: {
            marginBottom: 14,
            marginTop: 6,
            textAlign: "left",
        },
        inputLabel: {
            fontSize: 14,
            fontFamily: "Josefin Sans",
            color: "#000000",
        },
        annuler: {
            lineHeight: "30px",
        },
        titles: {
            fontWeight: 700,
            marginBottom: 20,
        },
    })
);
